
import { useState, useCallback } from "react";
import { AnalysisProgress } from "./types";

export function useProgressSimulation() {
  const startProgressSimulation = useCallback(() => {
    // Use a faster interval (150ms instead of 200ms) and larger increments
    return setInterval(() => {
      setProgress(prev => {
        if (prev.status === 'processing' && prev.progress < 95) {
          // Increase progress more quickly - add 3-7% each time
          return {
            ...prev,
            progress: Math.min(95, prev.progress + Math.floor(Math.random() * 5) + 3)
          };
        }
        return prev;
      });
    }, 150);
  }, []);

  const [progress, setProgress] = useState<AnalysisProgress>({
    progress: 0,
    status: 'idle',
    partialResults: undefined
  });

  return {
    progress,
    setProgress,
    startProgressSimulation
  };
}
